module.exports = __webpack_public_path__ + "static/RobotoSlab-VariableFont_wght-d5bc46370bbcd2b8ca12f8e3365dd566.ttf";